/**
 * List Schema of CentroDeCusto
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'

/* TODO: review generated schema */
export class ListCentroDeCustoSchema extends Schema {
  readonly name = 'ListCentroDeCusto'

  readonly fieldSet: FieldSet<CentroDeCusto> = {
    idCentroDeCustoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
